import {
  TextField,
  Container,
  Grid,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  Link,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { CopyIcon } from '../../../../icons/CopyIcon';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { SupportedList } from './SupportedList';

const MainContainer = styled('div')({
  display: 'block',
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: '1.5em',
  borderRadius: '8px',
  width: '337px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const CopyButton = styled('div')({
  borderLeft: 'solid 1px #E1E3EA',
  maxHeight: '2.5em',
  display: 'flex',
});

const Caption = styled(Typography)({
  marginTop: '1.3em',
});

const Heading = styled(Typography)({
  position: 'relative',
});

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const UrlTextBox = styled(Grid)(({ theme }) => ({
  clear: 'left',
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

const PaperContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

export function UnsupportedBrowser() {
  const appURL = window.location.href;

  const copyAppLink = () => {
    navigator.clipboard.writeText(appURL);
  };

  return (
    <>
      <Container>
        <MainContainer>
          <Header item lg={5}>
            <Heading variant="h1" gutterBottom>
              <ErrorIcon />
              New browser needed
            </Heading>
            <Typography variant="body1" gutterBottom>
              Oh no, your browser isn't supported! Download and install a new one from the list, copy the url below and
              paste it into your new browser to restart the test.
            </Typography>
          </Header>
          ​
          <PaperContainer item lg={5}>
            <StyledPaper>
              <SupportedList />
            </StyledPaper>
            <Caption variant="caption" align="center">
              We support the most recent and the two previous versions. Please{' '}
              <Link
                color="inherit"
                underline="always"
                target="_blank"
                rel="noopener"
                href="https://www.twilio.com/docs/video/javascript#supported-browsers"
              >
                visit our docs
              </Link>{' '}
              for more details.
            </Caption>
          </PaperContainer>
          <UrlTextBox item lg={5}>
            <TextField
              fullWidth={true}
              id="read-only-app-link"
              defaultValue={appURL}
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CopyButton>
                      <IconButton edge="end" onClick={copyAppLink}>
                        <CopyIcon />
                      </IconButton>
                    </CopyButton>
                  </InputAdornment>
                ),
                readOnly: true,
              }}
            />
          </UrlTextBox>
        </MainContainer>
      </Container>
    </>
  );
}
